import React, { useState } from 'react';

const PostPopup = ({ onClose, onSubmit }) => {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');

  const handleSubmit = () => {
    onSubmit({ title, body });
    onClose();
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#fff',
        padding: '20px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
        zIndex: 1000,
        width: '90%',
        maxWidth: '400px',
        borderRadius: '8px',
        fontFamily: 'Oswald, sans-serif',
      }}
    >
      <h2 style={{ fontFamily: "'PressStart2P', cursive" }}>Create Post</h2>
      <div style={{ marginBottom: '10px' }}>
        <label>Post Title</label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          maxLength={30}
          style={{ width: 'calc(100% - 20px)', padding: '10px 20px 10px 10px', marginTop: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
        />
      </div>
      <div style={{ marginBottom: '10px' }}>
        <label>Post Body</label>
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          style={{ width: 'calc(100% - 20px)', padding: '10px 20px 10px 10px', marginTop: '5px', height: '100px', borderRadius: '4px', border: '1px solid #ccc' }}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <button onClick={handleSubmit} style={{ fontFamily: 'Oswald, sans-serif', flex: 1, padding: '10px 20px', backgroundColor: '#FF007F', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', marginRight: '10px' }}>
          Submit
        </button>
        <button onClick={onClose} style={{ fontFamily: 'Oswald, sans-serif', flex: 1, padding: '10px 20px', backgroundColor: '#333', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default PostPopup;